import React, { useState } from "react";

import { MdOutlineAssignmentInd, MdRefresh } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import InputForms from "../../UiComponents/forms/InputForms";
import InputPassword from "../../UiComponents/forms/InputPassword";
import Button from "../../UiComponents/Button";
import BtnForms from "../../UiComponents/forms/BtnForms";
import styles from "./CreateAccountUser.module.scss";

export default function CreateAccountUser() {
  const [login, setLogin] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("abonné");
  const [validation, setValidation] = useState("");

  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

  const generatePassword = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    const passwordLength = 12;
    let generatedPassword = "";
    for (let i = 0; i < passwordLength; i++) {
      generatedPassword += chars.charAt(
        Math.floor(Math.random() * chars.length)
      );
    }

    setPassword(generatedPassword);
    setValidation(""); // Réinitialise les validations après génération
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!login || !name || !lastName || !email || !password) {
      setValidation("Tous les champs sont obligatoires.");
      return;
    }

    // Logique pour envoyer les données (par exemple, un appel API)
    console.log({
      login,
      name,
      lastName,
      email,
      password,
      role,
    });

    // Réinitialiser les champs après soumission
    setLogin("");
    setName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setRole("abonné");
    setValidation("Compte créé avec succès !");
  };

  return (
    <form onSubmit={handleSubmit} className={styles.formContainer}>
      {validation && <p className={styles.validationMessage}>{validation}</p>}

      <InputForms
        type="text"
        placeholder="Login"
        value={login}
        onChange={(e) => setLogin(e.target.value)}
        required
        svg={<FaUserAlt />}
      />

      <InputForms
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        svg={<AiOutlineMail />}
      />

      <InputForms
        type="text"
        placeholder="Nom"
        value={lastName}
        onChange={(e) => setLastName(capitalize(e.target.value))}
        required
        svg={<FaUserAlt />}
      />

      <InputForms
        type="text"
        placeholder="Prénom"
        value={name}
        onChange={(e) => setName(capitalize(e.target.value))}
        required
        svg={<FaUserAlt />}
      />

      <div className={styles.passwordContainer}>
        <InputPassword
          placeholder={password !== "" ? password : "Mot de passe"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button
          type="button"
          onPress={generatePassword}
          text="Générer"
          svg={<MdRefresh />}
          styles={"btnPrimary"}
        />
      </div>

      <div className={styles.selectContainer}>
        <label htmlFor="role">Rôle :</label>
        <select
          id="role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
        >
          <option value="abonné">Abonné</option>
          <option value="superAdmin">Support Team</option>
          <option value="superAdmin">SuperAdmin</option>
        </select>
      </div>

      <div className={styles.selectContainer}>
        <label htmlFor="role">Groupe :</label>
        <select
          id="role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
        >
          <option value="">Aucun</option>
          <option value="vyv3">Ecouter Voir</option>
          <option value="entendre">Entendre</option>
          <option value="krys">Krys</option>
          <option value="krys">Maitre Audio</option>
          <option value="krys">Phoneme Audition</option>
        </select>
      </div>

      <BtnForms text="Je crée un compte" svg={<MdOutlineAssignmentInd />} />
    </form>
  );
}
